export default function Footer() {
  return (
    <footer className="bg-[#060606] text-white px-6 md:px-12 pt-24 pb-10 mt-12 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto">
        <p className="font-cabinet font-black uppercase tracking-tighter leading-[0.9] text-[13vw] lg:text-[9vw] text-outline select-none">
          Real Life
        </p>
        <p className="font-cabinet font-black uppercase tracking-tighter leading-[0.9] text-[13vw] lg:text-[9vw] text-[#F5B301] select-none">
          Learners.
        </p>
        <p className="font-script text-2xl md:text-3xl text-white/50 mt-8 -rotate-1">Because learning to drive is only the beginning.</p>
        <div className="grid md:grid-cols-3 gap-10 border-t border-white/10 mt-16 pt-10">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mb-4">Service Area</p>
            <p className="text-sm text-white/70 leading-relaxed">Coolum to Caloundra<br />Sunshine Coast, QLD</p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mb-4">Talk</p>
            <p className="text-sm text-white/70 leading-relaxed">
              <a href="sms:0427779709" className="hover:text-[#F5B301] transition-colors duration-300">0427 779 709 (text Cam)</a>
              <br />
              <a href="mailto:reallifelearners@yahoo.com" className="hover:text-[#F5B301] transition-colors duration-300">reallifelearners@yahoo.com</a>
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mb-4">Follow</p>
            <div className="flex flex-col gap-2 text-sm text-white/70">
              <a href="https://instagram.com/real.lifelearners" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5B301] transition-colors duration-300 w-fit">Instagram — real.lifelearners</a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5B301] transition-colors duration-300 w-fit">Facebook — Real Life Learners Driving School</a>
              <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#F5B301] transition-colors duration-300 w-fit">Staff Login</a>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 mt-16 pt-6 border-t border-white/10">
          <p className="text-xs text-white/40">© 2026 Real Life Learners Driving School. All rights reserved.</p>
          <p className="text-xs text-white/40 uppercase tracking-widest">Coolum → Caloundra</p>
        </div>
      </div>
    </footer>
  );
}
